import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';

type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;

export interface InputProps extends SelectProps {
  id?: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

const addToArray = (value: any, newValue: string) => {
  return Array.from(new Set(value.concat([newValue])));
};

export const MultiSelect = ({
  label,
  id,
  tooltip,
  field,
  onValueChange,
  defaultValue = [],
}: InputProps) => {
  const [newValue, setNewValue] = React.useState<string>(null);
  const inputRef = React.useRef(null);

  const onAdd = () => {
    onValueChange(field, addToArray(defaultValue, newValue));
    inputRef.current.value = null;
  };

  const renderItem = (item: any) => (
    <div
      className="black bg-near-white items-center br3 flex justify-between mr2 mb2"
    >
      <span className="pa1 pa3-ns">{item}</span>
      <button
        type="button"
        className="red b dib link bg-transparent bw0 pointer dim ma0 pa1 pa3-ns"
        onClick={() => {
          onValueChange(
            field,
            defaultValue.filter((arrItem: any) => arrItem !== item),
          );
        }}
      >
        ✕
      </button>
    </div>
  );

  return (
    <BaseForm label={label} id={id} tooltip={tooltip}>
      <div className="relative mv2">
        <input
          className={theme.form.field.input}
          defaultValue={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          onKeyUp={(e) => {
            if (e.keyCode === 13) {
              e.preventDefault();
              onAdd();
            }
          }}
          placeholder="Add a new value…"
          ref={inputRef}
          type="text"
        />
        <button
          type="button"
          className="gold b dib link bg-transparent bw0 pointer dim absolute top-0 right-0 pa3"
          onClick={onAdd}
        >
          Add
        </button>
      </div>
      <div className="flex flex-wrap">{defaultValue.map(renderItem)}</div>
    </BaseForm>
  );
};
